import eurekaConfig from 'ui-theme/widgets/axel-publication-content/js/config';

const config = eurekaConfig;
config.collateral.figures.media.renderContent = true;
config.collateral.figures.media.renderNotes = true;
config.figures.all.fillInMissingData.titleEnabled = false;
config.figures.all.linkOpenAllinViewer.enabled = true;
config.figures.media.linkToViewer.enabled = true;
config.videoPlayer = {
    // LIT-528710
    ...eurekaConfig.videoPlayer,
    kaltura: {
        ...eurekaConfig.videoPlayer.kaltura,
        enabled: true,
        partnerId: '1315631',
        uiConfId: '53140472',
    },
};

export default config;
